import React, {Suspense} from "react";
import {Route, Routes} from "react-router-dom";
import OperadoresVetados from "../../../views/talentoHumano/OperadoresVetados/OperadoresVetados";
import VisualizarAsistencias from "../../../views/talentoHumano/VisualizarAsistencias/VisualizarAsistencias";

import PersonalView from "../../../views/talentoHumano/TablaPersonal/TablaPersonal";

import FormularioAltasTest from "../../../views/talentoHumano/FormularioAltas/TestForm.jsx";
import {ColaboradoresView} from "../../../views/talentoHumano/TablaColaboradores/TablaColaboradores";
import Descuentos from "../../../views/talentoHumano/Descuentos/Descuentos";
import EstadisticaDeOperadores from "../../../views/talentoHumano/EstadisticaDeOperadores/EstadisticaDeOperadores.jsx";
import VacacionesOperadores from "../../../views/talentoHumano/VacacionesOperadores/VacacionesOperadores";
import SolicitudesReclutamiento
    from "../../../views/talentoHumano/SolicitudesReclutamiento/SolicitudesReclutamiento.jsx";
import CatalogoSumaDrivers from "../../../views/talentoHumano/CatalogoSumaDrivers/CatalogoSumaDrivers";
import Vacantes from "../../../views/talentoHumano/Vacantes/Vacantes";

const TalentoHumano = () => {
    return (
        <Routes>
            <Route exact path="/th/operadores-vetados" element={<Suspense fallback={<>skeleton</>}>
                <OperadoresVetados></OperadoresVetados>
            </Suspense>}/>
            <Route exact path="/th/asistencia" element={<Suspense fallback={<>skeleton</>}>
                <VisualizarAsistencias></VisualizarAsistencias>
            </Suspense>}/>
            <Route exact path="/th/tabla-operadores" element={<Suspense fallback={<>skeleton</>}>
                <PersonalView></PersonalView>
            </Suspense>}/>
            <Route exact path="/th/tabla-colaboradores" element={<Suspense fallback={<>skeleton</>}>
                <ColaboradoresView></ColaboradoresView>
            </Suspense>}/>
            <Route exact path="/th/tabla-descuentos" element={<Suspense fallback={<>skeleton</>}>
                <Descuentos></Descuentos>
            </Suspense>}/>
            <Route exact path="/th/estadistica-operadores" element={<Suspense fallback={<>skeleton</>}>
                <EstadisticaDeOperadores></EstadisticaDeOperadores>
            </Suspense>}/>
            <Route exact path="/th/vacaciones-operadores" element={<Suspense fallback={<>skeleton</>}>
                <VacacionesOperadores/>
            </Suspense>}/>
            <Route exact path="/th/solicitudes-reclutamiento" element={<Suspense fallback={<>skeleton</>}>
                <SolicitudesReclutamiento/>
            </Suspense>}/>
            <Route exact path="/th/catalogo-sumadrivers" element={<Suspense fallback={<>skeleton</>}>
                <CatalogoSumaDrivers/>
            </Suspense>}/>
            <Route exact path="/th/vacantes" element={<Suspense fallback={<>skeleton</>}>
                <Vacantes/>
            </Suspense>}/>
        </Routes>
    )
}
export default TalentoHumano